module.exports = __webpack_public_path__ + "img/yilianGl17.03d57d4a.png";